<template>
  <div class="footer-component text-center">
    &copy; Japan Visualmedia Translation Academy Co.,Ltd.
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer-component {
  background-color: #31343d;
  color: #dcdcdc;
  padding: 0.2rem 0;
  width:100%;
  height:1.8rem;
}
</style>

